const BLACK_COLOR = "#000"
const RED_COLOR = "#f83a41"

export default [
  {
    src: "GBD101011_Black.jpg",
    modelName: "GBD101011",
    dimensions: "10” x 10” x 11”",
    logoDimensions: "6” x 6”",
    logo: { scaleY: 0.11894433301252867, scaleX: 0.20168220937640857, left: 286.76300846834874, top: 134.3978232858747, angle: 360 },
    options: [
      {
        color: BLACK_COLOR,
        src: "GBD101011_Black.jpg",
        thumbnail: "GBD101011_Black_sans.jpg",
      },
    ],
  },
  {
    src: "GBD121515_Black.jpg",
    modelName: "GBD121515",
    dimensions: "12” x 15” x 15”",
    logoDimensions: "10” x 12”",
    logo: { scaleY: 0.1329322544542722, scaleX: 0.2054509951572045, left: 282.3467032815977, top: 158.1532967184024, angle: 360 },
    options: [
      {
        color: BLACK_COLOR,
        src: "GBD121515_Black.jpg",
        thumbnail: "GBD121515_Black_sans.jpg",
      },
    ],
  },
  {
    src: "GBD151212_Black.jpg",
    modelName: "GBD151212",
    dimensions: "15” x 12” x 12”",
    logoDimensions: "12” x 10”",
    logo: { scaleY: 0.14751269519581603, scaleX: 0.25012277192749655, left: 257.0297449682366, top: 136.889735809733, angle: 359.91450650317574 },
    options: [
      {
        color: BLACK_COLOR,
        src: "GBD151212_Black.jpg",
        thumbnail: "GBD151212_Black_sans.jpg",
      },
      {
        color: RED_COLOR,
        src: "GBD151212_Red.jpg",
        thumbnail: "GBD151212_Red_sans.jpg",
      },
    ],
  },
  {
    src: "GBD181412_Black.jpg",
    modelName: "GBD181412",
    dimensions: "18” x 14” x 12”",
    logoDimensions: "12” x 12”",
    logo: { scaleY: 0.1339207133047495, scaleX: 0.22707618477058092, left: 282.20153341416494, top: 142.8372054346826, angle: 1 },
    options: [
      {
        src: "GBD181412_Black.jpg",
        thumbnail: "GBD181412_Black_sans.jpg",
        color: BLACK_COLOR,
      },
      {
        src: "GBD181412_Red.jpg",
        thumbnail: "GBD181412_Red_sans.jpg",
        color: RED_COLOR,
      },
    ],
  },
  {
    src: "GBD211414_Black.jpg",
    modelName: "GBD211414",
    dimensions: "21” x 14” x 14”",
    logoDimensions: "12” x 12”",
    logo: { scaleY: 0.14078959982270575, scaleX: 0.23872308020318064, left: 272.27759121629845, top: 141.6265123681543, angle: 1 },
    options: [
      {
        src: "GBD211414_Black.jpg",
        thumbnail: "GBD211414_Black_sans.jpg",
        color: BLACK_COLOR,
      },
      {
        src: "GBD211414_Red.jpg",
        thumbnail: "GBD181412_Red_sans.jpg",
        color: RED_COLOR,
      },
    ],
  },
  {
    src: "GBD211417_Black.jpg",
    modelName: "GBD211417",
    dimensions: "21” x 14” x 17”",
    logoDimensions: "12” x 12”",
    logo: { scaleY: 0.13251122774067212, scaleX: 0.22468625869804298, left: 282.57576657042927, top: 149.57874635209646, angle: 1 },
    options: [
      {
        color: BLACK_COLOR,
        src: "GBD211417_Black.jpg",
        thumbnail: "GBD211417_Black_sans.jpg",
      },
      {
        color: RED_COLOR,
        src: "GBD211417_Red.jpg",
        thumbnail: "GBD181412_Red_sans.jpg",
      },
    ],
  },
]
